// The waiting-room TV is paired once with a display token. The token travels in the URL FRAGMENT (#t=...), which a browser never sends to a
// server and never puts in a Referer header; the page moves it into storage and removes it from the address bar.

export const DISPLAY_TOKEN_KEY = 'lis_queue_display_token';
const TOKEN_SHAPE = /^qdt_[A-Za-z0-9_-]{20,80}$/;

/** The token in a URL hash such as "#t=qdt_abc...", or null when there is none or it does not look like one. */
export const readPairingToken = (hash) => {
  const match = /(?:^#|&)t=([^&]+)/.exec(hash || '');
  if (!match) return null;
  let token;
  try { token = decodeURIComponent(match[1]); } catch (e) { return null; }
  return TOKEN_SHAPE.test(token) ? token : null;
};

export const pairingUrl = (origin, token) => `${String(origin || '').replace(/\/+$/, '')}/queue/display#t=${token}`;

export const loadStoredToken = () => {
  try {
    const t = window.localStorage.getItem(DISPLAY_TOKEN_KEY);
    return t && TOKEN_SHAPE.test(t) ? t : null;
  } catch (e) { return null; }
};

export const storeToken = (token) => {
  try { window.localStorage.setItem(DISPLAY_TOKEN_KEY, token); } catch (e) { /* storage blocked: the screen works until it is reloaded */ }
};

export const clearStoredToken = () => {
  try { window.localStorage.removeItem(DISPLAY_TOKEN_KEY); } catch (e) { /* nothing stored */ }
};

/** Tokens as the settings list shows them. */
export const displayTokenStatusLabel = (status) => ({ ACTIVE: 'Active', EXPIRED: 'Expired', REVOKED: 'Revoked' }[status] || status);

/** Up to three letters or digits, upper case: what a token prefix may be. */
export const cleanPrefixInput = (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 3);

/** The first problem with the queue settings, or null. Mirrors the server, which decides. */
export const validateQueueConfig = (cfg) => {
  const prefixes = [cfg.prefixRegistration, cfg.prefixBilling, cfg.prefixCollection, cfg.prefixReport].map((p) => String(p || '').trim());
  if (prefixes.some((p) => p.length === 0)) return 'Every stage needs a prefix of one to three letters or digits.';
  if (new Set(prefixes).size !== prefixes.length) return 'Each stage needs its own prefix, otherwise two desks would print the same token.';
  const days = Number(cfg.displayTokenDays);
  if (!Number.isInteger(days) || days < 1 || days > 365) return 'A display token can be valid for 1 to 365 days.';
  return null;
};
